export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
    color: {},
  },
  computed: {
    imageStyleModifiers() {
      return {
        'border-color': this.color,
        'background-image': `url(${this.contract.contractImageSmallUrl})`,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contract-image/market-contract-image.js